module.exports = __webpack_public_path__ + "static/media/apparel3.f09e9ce0.jpg";